<template>
  <a-layout style="padding:16px;" class="launch-box">
    <a-card class="launch-application" :style="{height:cardHeight+'px'}" v-if="loaded">
      <div class="launch-application-panel" v-for="(item,index) in layout" v-if="getLen(item.children)" :key="index">
        <div class="launch-application-panel-title">
          <span>{{item.panel}}
            <span class="gray">({{getLen(item.children)}})</span>
            <!-- <span class="gray">({{item.children.length}})</span> -->
          </span>
          <span class="gray btn" @click="item.showChild=!item.showChild">{{item.showChild?'收起':'展开'}}</span>
        </div>
        <div class="launch-application-panel-main" :class="item.showChild?'showChild':'hideChild'">
          <div class="launch-application-entry" v-for="(child,ind) in item.children" :key="'child_'+ind" v-if="(child.permissionId && permissions.includes(child.permissionId)) || child.permissionId === undefined" @click="createApplication(child)">
            <p :class="'iconbox '+child.iconBg">
              <a-icon slot="suffixIcon" :component="child.icon" />
            </p>
            <p v-if="child.isOpened">{{child.name}}</p>
            <p v-else style="line-height:18px;">
              {{child.name}}<br>
              <span style="font-size:12px;color:#999;">敬请期待</span>
            </p>
          </div>
        </div>
      </div>
    </a-card>
    <a-spin tip="加载中..." v-else></a-spin>
    <a-modal class="teamModal" v-model="visible" title="选择预算调整团队" :maskClosable="false" :ok-button-props="{ props: { disabled: Boolean(errorMsg) } }" @ok="confirm" @cancel="cancelModal">
      <div style="display:flex;">
        <div class="label">选择团队：</div>
        <div>
          <a-select style="width: 270px" v-model="selectedTeam" @change="onSelectTeam">
            <a-select-option v-for="item in budgetTeams" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
          </a-select>
          <div class="error">{{errorMsg}}</div>
        </div>
      </div>

    </a-modal>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import { addUUID } from "./../../utils/tools";
import { getApplicationPermissions } from "../../services/CommonService.js";
import {
  getBudgetChangeDefaultParams,
  getBudgetTeams
} from "../../services/BudgetChangeService.js";
import * as dd from "dingtalk-jsapi";

export default {
  components: {},
  data() {
    return {
      breadcrumb: [
        {
          label: "发起申请",
          path: ""
        }
      ],
      cardHeight: 0,
      loaded: true,
      layout: [
        {
          panel: "财务审批",
          showChild: true,
          children: [
            {
              name: "报销",
              type: "createReimbursement", // 跳转的对应路由名称
              iconBg: "bgBlue",
              icon: "SvgIcBaoxiao",
              isOpened: true, // 是否已开发完可对外开发放
              permissionId: 1 //显示报销入口对应的权限数值
            },
            {
              name: "采购",
              type: "createReimbursement",
              iconBg: "bgRed",
              icon: "SvgIcCaigou",
              isOpened: false,
              permissionId: 7 //显示该入口对应的权限数值
            },
            {
              name: "付款",
              type: "createApplication",
              iconBg: "bgPurple",
              icon: "SvgIcFukuan",
              isOpened: true,
              permissionId: 2 //显示该入口对应的权限数值
            },
            {
              name: "预算调整",
              type: "createBudgetApplication",
              iconBg: "bgGreen",
              icon: "SvgIcYusuan",
              isOpened: true,
              permissionId: 6 //显示该入口对应的权限数值
            }
          ]
        },
        {
          panel: "财务审批-项目",
          showChild: true,
          children: [
            {
              name: "项目报销",
              type: "createProExpendReimbursement",
              iconBg: "bgBlue",
              icon: "SvgIcBaoxiao",
              isOpened: false,
              permissionId: 9 //显示该入口对应的权限数值
            },
            {
              name: "项目付款",
              type: "createProExpendPayment",
              iconBg: "bgPurple",
              icon: "SvgIcFukuan",
              isOpened: false,
              permissionId: 8 //显示该入口对应的权限数值
            }
          ]
        },
        {
          panel: "系统权限相关",
          showChild: true,
          children: [
            {
              name: "云端专病库权限",
              type: "createExclusivenessLibrary",
              iconBg: "bgBlue2",
              icon: "SvgIcYunduan",
              isOpened: true,
              permissionId: 11 //显示该入口对应的权限数值
            },
            {
              name: "资产管理",
              type: "createGuziLibrary",
              iconBg: "bgGreen2",
              icon: "SvgIcGuzi",
              isOpened: true,
              permissionId: 12
            },
            {
              name: "医院科室信息审批",
              type: "workbench",
              iconBg: "bgPurple",
              icon: "SvgIcGuzi",
              isOpened: true,
              permissionId: 13
            },
          ]
        }
      ],
      permissions: [],
      canBudgetChange: true,
      budgetInfo: [],
      budgetInfoInit: false,
      budgetTeams: [],
      visible: false,
      selectedTeam: undefined,
      errorMsg: undefined
    };
  },

  computed: {
    getLen() {
      return function(params) {
        let len = 0;
        params &&
          params.forEach(element => {
            if (
              (element.permissionId &&
                this.permissions.includes(element.permissionId)) ||
              element.permissionId === undefined
            ) {
              len++;
            }
          });
        return len;
      };
    }
  },

  created() {
    this.cardHeight = document.documentElement.clientHeight - 150;
    const vm = this;
    window.onresize = function() {
      vm.cardHeight = document.documentElement.clientHeight - 150;
    };
    getApplicationPermissions().then(res => {
      if (res.status === "success") {
        this.loaded = true;
        this.permissions = res.data;
      } else if (res.message) {
        this.$Message.error(res.message);
      }
    });
    getBudgetTeams().then(res => {
      if (res.status === "success") {
        this.budgetTeams = res.data;
      } else if (res.message) {
        this.$Message.error(res.message);
      }
    });
  },

  methods: {
    createApplication(info) {
      if (!info.isOpened) return;
      if (info.type === "createExclusivenessLibrary") {
        if (location.host === "oa.linkdoc.com") {
          window.location.href = "https://linkhub.linkdoc.com/apply";
        } else {
          window.location.href = "https://new-portal2.qa.linkdoc.com/apply";
        }
        return;
      }
      if (info.type === "workbench") {
        if (location.host === "oa.linkdoc.com") {
          window.location.href = "https://odp.linkdoc.com/app#/approvalEnter";
        } else {
          window.location.href = "http://odp-fe-service.qa.linkdoc.com/app#/approvalEnter";
        }
        return;
      }
      if(info.type === "createGuziLibrary") {
        if(dd.env.platform === "notInDingTalk") {
          window.location.href = 'https://sso.corp.linkdoc.com/#/?client_id=appF7WhR6fRwG8Q2&response_type=code&redirect_uri=http%3A%2F%2Fmassets.linkdoc.com%2F%23%2Flogin%3Fpushto%3D%2F'
          return
        }
        window.location.href = "https://massets.linkdoc.com";
        return;
      }
      if (info.type !== "createBudgetApplication") {
        this.$router.replace({
          name: info.type
        });
      } else if (info.type === "createBudgetApplication") {
        this.visible = true;
      }
    },
    onSelectTeam(e) {
      this.errorMsg = undefined;
      getBudgetChangeDefaultParams({
        change_group_info: e
      }).then(res => {
        if (res.status === "failed") {
          this.errorMsg = res.message;
        } else if (res.status === "success") {
          if (res.data.budgetInfo) {
            this.budgetInfo = res.data.budgetInfo;
          }
        }
      });
    },
    resetModal() {
      this.errorMsg = undefined;
      this.selectedTeam = undefined;
    },
    confirm() {
      this.visible = false;
      this.$router.replace({
        name: "createBudgetApplication",
        query: {
          change_group_info: this.selectedTeam
        }
      });
      this.resetModal();
    },
    cancelModal() {
      this.visible = false;
      this.resetModal();
    }
  }
};
</script>

<style lang="less">
.launch-application {
  &-panel {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 0;
    border-bottom: #dedede solid 1px;
    &-title {
      width: 100%;
      line-height: 22px;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      span.gray {
        color: rgba(0, 0, 0, 0.45);
      }
      span.btn {
        cursor: pointer;
      }
    }
    &-main {
      display: flex;
      overflow: hidden;
    }
    &-main.showChild {
      height: 70px;
      transition: height 0.1s linear;
    }
    &-main.hideChild {
      height: 0px;
      transition: height 0.1s linear;
    }
  }
  &-panel:first-child {
    padding-top: 0;
  }
  &-panel:last-child {
    border-bottom: none;
  }
  &-entry {
    display: flex;
    box-sizing: border-box;
    padding: 16px;
    width: 200px;
    padding-right: 6px;
    height: 70px;
    border: #ddd solid 1px;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 14px;
    cursor: pointer;
    p {
      line-height: 36px;
    }
    .iconbox {
      height: 36px;
      width: 36px;
      padding: 3px 7px;
      margin-right: 8px;
      border-radius: 4px;
      i {
        font-size: 22px;
        color: #fff;
      }
    }
    .bgBlue {
      background: #1492ee;
    }
    .bgRed {
      background: #fc440d;
    }
    .bgPurple {
      background: #701aff;
    }
    .bgGreen {
      background: #38c260;
    }
    .bgGreen2 {
      background: #13C2C2;
    }
    .bgBlue2 {
      background: #2f54eb;
    }
  }
}
.teamModal {
  .label {
    height: 32px;
    width: 150px;
    line-height: 32px;
    text-align: right;
  }
  .error {
    color: #fc440d;
    margin-top: 5px;
    width: 100%;
    height: 20px;
  }
  .ant-modal-close {
    top: 10px;
    right: 10px;
  }
}
</style>
